module.exports = __webpack_public_path__ + "static/img/0000个人网站.128e49c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000个人网站.jpg
// module id = p/Qw
// module chunks = 0